<template>
  <Badge :value="label" :severity="severity" class="zapi-badge-pill" />
</template>

<script>
export default {
  name: 'ZapiBadgePill',
  props: {
    label: { type: String, required: true },
    severity: { type: String, default: 'danger' }
  }
}
</script>

<style scoped>
.zapi-badge-pill,
.zapi-badge-pill :deep(.p-badge) {
  border-radius: 999px !important;
  white-space: nowrap !important; /* Mantiene el texto en una sola línea horizontal */
  height: auto !important; /* Quita el alto fijo por defecto de PrimeVue */
  min-height: 1.5rem;
  padding: 0.25rem 0.6rem;
  line-height: 1.2;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}
</style>